import { CheckCircle2 } from "lucide-react";

/** Tiny green "Read" pill — for blog cards / lists. Hidden when `read` is false. */
export function ReadBadge({ read, className = "", withLabel = true }) {
  if (!read) return null;
  return (
    <span
      data-testid="read-badge"
      className={`inline-flex items-center gap-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800 ${className}`}
      title="You've read this"
    >
      <CheckCircle2 className="w-3.5 h-3.5" />
      {withLabel && "Read"}
    </span>
  );
}

/** Horizontal progress bar showing X of N complete. */
export function PathwayProgress({ read, total, className = "", size = "md" }) {
  const pct = total > 0 ? Math.round((read / total) * 100) : 0;
  const height = size === "sm" ? "h-1.5" : "h-2";
  const complete = total > 0 && read === total;
  return (
    <div data-testid="pathway-progress" className={className}>
      <div className="flex items-center justify-between text-xs text-slate-600 dark:text-slate-400 mb-1">
        <span className="uppercase tracking-widest">
          {complete ? "Complete" : "Progress"}
        </span>
        <span className="tabular-nums">
          {read}/{total} <span className="text-slate-400">· {pct}%</span>
        </span>
      </div>
      <div className={`w-full ${height} bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden`}>
        <div
          className={`${height} rounded-full transition-all duration-500 ${complete ? "bg-emerald-600" : "bg-sky-600"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
